export const checkUserAgent = {
	data() {
		return {}
	},
	methods: {
		checkUserAgent(object) {
      let rst = true
      if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
        var ua = navigator.userAgent.toLowerCase()
        if (!(ua.match(/MicroMessenger/i) == "micromessenger")) {
          rst = false
        }
      } else {
        rst = false
      }
      if (rst) {
        wx.miniProgram.getEnv((res)=>{
          if (res.miniprogram) {
            object&&object.success&&object.success('miniprogram')
          } else {
            object&&object.success&&object.success('wechat')
          }
        })
      } else {
        object&&object.success&&object.success('h5')
      }
		}
	}
}
